import React from 'react';
import moment from 'moment';

const ProductCard = ({ product }) => {
  return (
    <div className="w-full md:w-1/2 md:pl-4 mb-5">
      <div className="h-76 bg-white rounded px-6 py-10">
        <h1 className="text-4xl font-bold mb-3">Product Info</h1>
        <ul>
          <li className="py-1">
            Start date -{' '}
            <span className="text-sm">{moment(product.startDate).format('MMMM Do, YYYY')}</span>
          </li>
          <li className="py-1">
            Price - <span className="text-sm">{product.pricePerAcre}</span>
          </li>
          <li className="py-1">
            Duration - <span className="text-sm">{product.duration} month(s)</span>
          </li>
          <li className="py-1">
            Acreage -{' '}
            <span className="text-sm"> {product.acreage + product.acreageSold} Acres</span>
          </li>
          <li className="py-1">
            Projected Return -{' '}
            <span className="text-sm">{product.projectedReturnsPerAcre}% (Per/Acre)</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ProductCard;
